import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { MatLegacyTabChangeEvent as MatTabChangeEvent, MatLegacyTabGroup as MatTabGroup } from '@angular/material/legacy-tabs';
import { forkJoin } from 'rxjs';
import { ScoreDetails, UserMotivationDetails } from 'src/app/all-motivations/model/all-motivations.interface';
import config from 'src/app/config';
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { ClaroAlertTypeEnum } from 'src/app/moov-common/components/claro-alert/claro-alert.component';
import { MotivationPartialViewComponent } from 'src/app/moov-common/components/motivation-partial-view/motivation-partial-view/motivation-partial-view.component';
import { Gender } from 'src/app/moov-common/enum/gender.enum';
import { IssueData, IssueSelectionData, MoovData, MoovInstanceData, MoovViewData, SubjectData } from 'src/app/moov-common/services/challenge/challenges-data';
import { AbstractChallengesService } from 'src/app/moov-common/services/challenge/challenges.abstract.service';
import { AbstractMotivationsService } from 'src/app/moov-common/services/motivation/motivations.abstract.service';
import { AccountTypeEnum, CareerProcessTypeEnum, DiscoveryStatusEnum, PersonalUserData, UserAlert, UserMinimalData } from 'src/app/moov-common/services/personal-user-data/personal-user-data';
import { AbstractPersonalUserDataService } from 'src/app/moov-common/services/personal-user-data/personal-user-data.abstract.service';
import { UtilsService } from 'src/app/moov-common/services/utils/utils.service';
import { MatDialog } from '@angular/material/dialog';
import { QuickActionSelection } from 'src/app/moov-common/components/quick-actions/quick-actions/quick-actions.component';
import { FeatureID } from 'src/app/moov-common/enum/feature.enum';
import { animate, group, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-team-member-details-view',
  templateUrl: './team-member-details-view.component.html',
  styleUrls: ['./team-member-details-view.component.scss'],
  animations: [
  
    trigger('slideInOut', [
        state('in', style({
            'max-height': '500px', 'opacity': '1', 'visibility': 'visible'
        })),
        state('out', style({
            'max-height': '0px', 'opacity': '0', 'visibility': 'hidden'
        })),
        transition('in => out', [group([
            animate('400ms ease-in-out', style({
                'opacity': '0'
            })),
            animate('600ms ease-in-out', style({
                'max-height': '0px'
            })),
            animate('700ms ease-in-out', style({
                'visibility': 'hidden'
            }))
        ]
        )]),
        transition('out => in', [group([
            animate('1ms ease-in-out', style({
                'visibility': 'visible'
            })),
            animate('600ms ease-in-out', style({
                'max-height': '500px'
            })),
            animate('800ms ease-in-out', style({
                'opacity': '1'
            }))
        ]
        )])
    ]),
  ]  
})
export class TeamMemberDetailsViewComponent  extends BaseComponent implements OnInit {
  teamMemberDetails: UserMinimalData; 
  motivationsDetails: UserMotivationDetails[];
  subjectsDetails: SubjectData[];
  issuesDetails: IssueData[];
  issuesMenuList: IssueSelectionData[];
  activeMoovsDetails: MoovInstanceData[];
  pastMoovsDetails: MoovInstanceData[];
  topRecommendedMoovs: MoovData[];
  selectedMoovData: MoovViewData;
  isMissingRelationship: boolean = false;
  motivationsImagesRootFolder = 'assets/motivations/';
  peopleImagesRootFolder = 'assets/common/';
  moovsImagesRootFolder = 'assets/moovs/';
  imageRootFolder = 'assets/teamMemberView/';
  motivationsImageRootFolder= 'assets/motivations/';
  userAlerts: Array<UserAlert> = [];
  moovWizardOpened: boolean = false;
  makeMoovWizardSelectedIssue: string = "";
  makeMoovWizardSelectedMotivation: string = "";
  isDataNotUpdatedWarning = false;
  isForcePresentNotUpdatedData = false;

  @Input() counterpartId: string;
  @Input() quickAccessMoovId: string = "";
  @Input() tabToDisplay: number;
  @Output() makeMoovEvent = new EventEmitter();
  @Output() activeMoovsChangedEvent = new EventEmitter();
  @Output() openMoovDetailsEvent = new EventEmitter();
  @Output() closeEvent = new EventEmitter();
  @ViewChild("moovSideNav") moovSideNavRef: MatSidenav;
  @ViewChild("teamMemberViewTabs") teamMemberViewTabs: MatTabGroup;

  selectedActiveMoov: MoovInstanceData;
  latestActiveMoov: MoovInstanceData;
  selectedMoov: MoovData;
  selectedMoovIsPastMoov: boolean;
  selectedMoovIsActiveMoov: boolean;
  currMotivation: string;
  isImportant : boolean = false;
  isSelectedActiveMoov : boolean = false;
  isLoadingScoreDetails : boolean = true;
  scoreDetails : ScoreDetails | null = null;
  nowValue = new Date();
  pastMoovsCount = 0;
  activeMoovsViewMode: MoovsViewPresentationModeEnum = MoovsViewPresentationModeEnum.NONE;
  activeMoovsViewModeEnum = MoovsViewPresentationModeEnum;
  alertTypeEnum = ClaroAlertTypeEnum;
  showLoading: boolean;
  MOOVS_TAB_INDEX = 0;
  INSIGHTS_TAB_INDEX = 1;
  presentRaiseDriver = false;
  isDiscoveryDone : boolean = false;
  showMoovsTab: boolean = true;
  showInsightsTab: boolean = false;
  showSendReminderBtn: boolean = true;
  state : string = 'out';
  isMemberInCareerProccess : boolean = false;

  constructor(private readonly personalUserService: AbstractPersonalUserDataService, 
              private readonly motivationsService: AbstractMotivationsService,
              private readonly challengesService: AbstractChallengesService,
              public dialog: MatDialog,
              public readonly utilsService: UtilsService) {
    super();
    this.motivationsDetails = [];
    this.pastMoovsDetails = [];
    this.activeMoovsDetails = []; 
    this.selectedMoovIsPastMoov = false;
    this.selectedMoovIsActiveMoov = false;
    this.isMissingRelationship = false;
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.setActiveTab(this.tabToDisplay);

      if (this.counterpartId != undefined)
      {
        this.getTeamMemeberData();
        this.getMemeberMotivations(this.counterpartId);
        this.getTopRecommendedMoovs();
        this.getIsMissingRelationship();
        this.getAlertsForCounterpart();
        // this.getMemberScore();
        this.verifyPresentRaiseDriver();

        if (this.quickAccessMoovId != undefined && this.quickAccessMoovId != ""){
          this.openQuickAccessMoov(this.quickAccessMoovId);
          // remove quick access marker - so we will not reopen 
          this.quickAccessMoovId = "";
        }
      }
  }

  ngAfterViewInit(): void{
    this.analytics.teamMemberDetailsViewPage();
  }

  ngOnChanges(changes: SimpleChanges) : void {
    if (changes.counterpartId == undefined){
      return;
    }


    if (changes.counterpartId.currentValue != changes.counterpartId.previousValue && !changes.counterpartId.firstChange){
      if (this.counterpartId != undefined)
      {
        this.showLoading = true;
        this.setActiveTab(this.tabToDisplay);
        // console.log('in tmv ngOnChanges userCOIData is '+JSON.stringify(this.userCOIData));

        this.getTeamMemeberData();
        this.getMemeberMotivations(this.counterpartId);
        this.getTopRecommendedMoovs();
        this.getIsMissingRelationship();
        this.getAlertsForCounterpart();
      }
    } 
  }

  verifyPresentRaiseDriver() : void{
    this.personalUserService.verifyFeature(FeatureID.driverMoovsForTeam).subscribe(presentDriverMoovs => {
      this.presentRaiseDriver = presentDriverMoovs;
    });
  }
  

  setActiveTab(tabIndex: number) {
    this.showLoading = true;
    if (this.teamMemberViewTabs)
      this.teamMemberViewTabs.selectedIndex = tabIndex;
    this.showMoovsTab = (tabIndex === this.MOOVS_TAB_INDEX);
    this.showInsightsTab = (tabIndex === this.INSIGHTS_TAB_INDEX);
  }

  makeMoov() {
    // console.log(`in tmv makeMoov`);
    // this.analytics.send(GAEventsCategories.TeamMemberView, "view_actions", "open_make_moov", "", {"userMail":this.user?.mailAddress, "counterpartMail" : this.teamMemberDetails.mailAddress});

    this.makeMoovEvent.emit();
  }

  makeDirectMoov(selectedAction: QuickActionSelection) {
    this.makeMoovWizardSelectedIssue = selectedAction.actionId;
    this.makeMoovWizardSelectedMotivation = selectedAction.motivationId;
    this.moovWizardOpened = true;
  }

  raiseDriver(selectedMotivationId: string){
    this.makeMoovWizardSelectedIssue = 'IS_H_010';
    this.makeMoovWizardSelectedMotivation = selectedMotivationId;
    this.moovWizardOpened = true;
  }

  isTeamMemberMale() : boolean{
    return (this.teamMemberDetails.gender == Gender.MALE);
  }

  getTeamMemeberData():void {
    this.personalUserService.getUserDetails(this.counterpartId).subscribe((userDetails:PersonalUserData) => {
      // console.log(`getTeamMemeberData details are ${JSON.stringify(userDetails)}`);
      this.teamMemberDetails = userDetails;  
      if (this.teamMemberDetails?.careerProcessType == CareerProcessTypeEnum.INDEVIDUAL_CONSULTANT_LEAD
          && userDetails.accountType !== AccountTypeEnum.CAREER_INDEPENDENT && userDetails.accountType !== AccountTypeEnum.CAREER_INDEPENDENT_US){
        this.isMemberInCareerProccess = true;
        // supress alert for career type
        this.isDataNotUpdatedWarning = false;
      }
      
      // console.log(`in TMV got personal data ${JSON.stringify(this.teamMemberDetails)}`);
      this.showLoading = false;
      this.verifyDiscoveryStatus();
      this.refreshMoovs();

      // we might get here after all other data was retreived
      this.calcShouldTopRecommendedMoovsBePresented();
      this.getMemberScore();
    });
  }

  getMemeberMotivations(id:string):void{
    // console.log(`trying to fetch user motivations with id ${id}`);
    this.motivationsService.getMotivationsForUser(id).subscribe((motivationsDetails :UserMotivationDetails[]) => {
      if (motivationsDetails.length == 0){
        return;
      }
      // console.log(`getMemeberMotivations ${JSON.stringify(motivationsDetails)}`);
      this.motivationsDetails = motivationsDetails.sort((motivation1, motivation2) => {
        if (motivation1.gapFactor! < motivation2.gapFactor!){
          return 1;
        }
        else if (motivation1.gapFactor! > motivation2.gapFactor!){
          return -1;
        }
        else{
          return 0;
        }
      });

      let temp_isDataNotUpdatedWarning = false;

      if (!this.isMemberInCareerProccess){
        for (let currMotivation of this.motivationsDetails){
          if (!currMotivation.isGapDataRelevant){
            temp_isDataNotUpdatedWarning = true;
          }
        }  
      }
      this.isDataNotUpdatedWarning = temp_isDataNotUpdatedWarning;

      // this.scoreDetails = this.utilsService.getScoreValuesForPerson(this.motivationsDetails);
      // console.log (`in TMV getMemeberMotivations scoreDetails = ${JSON.stringify(this.scoreDetails)}`);
    });
  }

  getActiveAndPastMoovs():void {
    forkJoin({
      pastMoovs : this.challengesService.getPastMoovsForUserCounterpart(this.counterpartId),
      activeMoovsList : this.challengesService.getActiveMoovsForUserCounterpart(this.counterpartId)
    }).subscribe(({pastMoovs, activeMoovsList})=>{
      this.pastMoovsDetails = pastMoovs;
      this.pastMoovsCount = this.pastMoovsDetails.length;

      if (activeMoovsList != undefined && activeMoovsList.length > 0){
        // sort active moovs list
        activeMoovsList = activeMoovsList.sort((am1, am2) => {
          if (am1.plannedEndDate > am2.plannedEndDate){
            return 1;
          }
          else if (am1.plannedEndDate < am2.plannedEndDate){
            return -1;
          }
          else{
            return 0;
          }

        });

        // get the latest active moov:
        this.latestActiveMoov = activeMoovsList.reduce((am1, am2) => am1.startDate > am2.startDate ? am1 : am2);
      };

      this.activeMoovsDetails = activeMoovsList;

      if (activeMoovsList){
        this.teamMemberDetails.activeMoovsCount = activeMoovsList.length;
      }
      else{
        this.teamMemberDetails.activeMoovsCount = 0;
      }

      if (this.activeMoovsViewMode == MoovsViewPresentationModeEnum.NONE){
        if (this.activeMoovsDetails.length > 0){
          this.activeMoovsViewMode = MoovsViewPresentationModeEnum.ACTIVE_MOOVS;
        }
        else if (this.pastMoovsCount > 0){
          // no Active Moovs and there are past moovs
          this.activeMoovsViewMode = MoovsViewPresentationModeEnum.PAST_MOOVS;
        }
      }

      this.calcShouldTopRecommendedMoovsBePresented();
    });

  }

  getTopRecommendedMoovs():void {
    // console.log(`trying to top recommended moovs`);
    this.challengesService.getTopRecommendedMoovs(this.counterpartId).subscribe(topRecommendedMoovs => {
      // console.log(JSON.stringify(activeMoovDetails));
      this.topRecommendedMoovs = topRecommendedMoovs;

      if (this.topRecommendedMoovs && this.topRecommendedMoovs.length > 0){
        this.isImportant = this.topRecommendedMoovs[0].score > config.userPayAttentionScoreThreshold;
      }
      this.calcShouldTopRecommendedMoovsBePresented();
    });    
  }

  openMotivation(motivationId:string): void{
    this.dialog.open(MotivationPartialViewComponent, {
      height: '500px',
      width: '600px',
      data: {selectedMotivationId:motivationId, isRTL:this.isRTL, isSelf:false}
    });
  }

  verifyDiscoveryStatus(): void {
    this.isDiscoveryDone = this.teamMemberDetails.discoveryStatus == DiscoveryStatusEnum.DONE;
  }

  openActiveMoov (activeMoovId: string): void {
    // get ActiveMoovDetails

    const selectedActiveMoovDetails = this.activeMoovsDetails.find (am => am.id == activeMoovId);

    if (selectedActiveMoovDetails == undefined){
      return;
    }

    // this.selectedActiveMoov = selectedActiveMoovDetails;

    if (selectedActiveMoovDetails.moovData == undefined){
      return;
    }
    this.selectedMoovData = {activeMoovDetails:selectedActiveMoovDetails,moovDetails:selectedActiveMoovDetails.moovData, isPastMoov:false, isActiveMoov:true, counterpartId:this.teamMemberDetails.id};  
    this.isSelectedActiveMoov = true;
    this.moovSideNavRef.open();
  }

  openPastMoov (pastMoovId: string): void {
    const selectedPastMoovDetails = this.pastMoovsDetails.find (pm => pm.id == pastMoovId);

    if (selectedPastMoovDetails == undefined){
      return;
    }

    if (selectedPastMoovDetails.moovData == undefined){
      return;
    }

    this.selectedMoovData = {activeMoovDetails:selectedPastMoovDetails,moovDetails:selectedPastMoovDetails.moovData, isPastMoov:true, isActiveMoov:true, counterpartId:this.teamMemberDetails.id};  
    this.isSelectedActiveMoov = true;
    this.moovSideNavRef.open();
  }


  closeMoovView(): void{
    // console.log(`in tmdv closeMoovView`);
    this.moovSideNavRef.close();
    this.isSelectedActiveMoov = false;
  }

  tmvTabChanged(selectedTab: MatTabChangeEvent){
    if (selectedTab.index == this.MOOVS_TAB_INDEX){
      this.calcShouldTopRecommendedMoovsBePresented();
      this.analytics.teamMemberMoovsTabSelected(this.counterpartId);
    }
    else {
      if (selectedTab.index == this.INSIGHTS_TAB_INDEX) {
          this.analytics.teamMemberInsightsTabSelected(this.counterpartId);
      }
    }

    this.showMoovsTab = (selectedTab.index === this.MOOVS_TAB_INDEX);
    this.showInsightsTab = (selectedTab.index === this.INSIGHTS_TAB_INDEX);
  }

  calcShouldTopRecommendedMoovsBePresented(): void{
    // console.log(`in TMV calcShouldTopRecommendedMoovsBePresented`);
    let shouldTopRecommendedBePresented = false;
    
    // console.log(`in TMV calcShouldTopRecommendedMoovsBePresented trm is ${this.topRecommendedMoovs}`);

    if (this.topRecommendedMoovs != undefined  && this.teamMemberDetails != undefined && this.topRecommendedMoovs.length > 0 && this.teamMemberDetails.discoveryStatus == DiscoveryStatusEnum.DONE && !this.isMissingRelationship){
      if (this.pastMoovsDetails.length != 0 || this.activeMoovsDetails.length != 0){
        // only if this user already has some history         
        shouldTopRecommendedBePresented = true;
      }
    }
  }

  openQuickAccessMoov(moovId: string) : void{

    this.challengesService.getMoovDetailsForCounterpart(moovId, this.counterpartId).subscribe(moovDetails => {
      let openMoovDetails :MoovViewData = {moovDetails:moovDetails, isPastMoov:false, isActiveMoov:false, counterpartId:this.counterpartId};
    
      this.analytics.recommendedMoovReviewed(this.counterpartId, moovDetails.id);
      this.openMoovDetailsEvent.emit(openMoovDetails);
    });

  }

  openTopRecommendedMoov (): void {
    if (this.topRecommendedMoovs == undefined || this.topRecommendedMoovs.length == 0){
      return;
    }

    let recommendedMoovId = this.topRecommendedMoovs[0].id;
    // this.analytics.send(GAEventsCategories.TeamMemberView, "view_actions", "open_recommended_moov", "", {"userMail":this.user?.mailAddress, "counterpartMail" : this.teamMemberDetails.mailAddress, "moovId" : recommendedMoovId});

    const selectedMoovDetails = this.topRecommendedMoovs.find (am => am.id == recommendedMoovId);

    if (selectedMoovDetails == undefined){
      return;
    }

    let openMoovDetails :MoovViewData = {moovDetails:selectedMoovDetails, isPastMoov:false, isActiveMoov:false, counterpartId:this.teamMemberDetails.id};
    
    this.analytics.recommendedMoovReviewed(this.counterpartId, recommendedMoovId);
    this.openMoovDetailsEvent.emit(openMoovDetails);
  }

  refreshMoovs(): void{
  this.getActiveAndPastMoovs(); 
  // this.getTopRecommendedMoovs();
  }

  activeMoovEnded(activeMoovId: string): void{
    // console.log(`in tmdv activeMoovEnded`);
    this.isSelectedActiveMoov = false;
    this.moovSideNavRef.close();
    this.refreshMoovs();
  }

  moovActivated(moovId: string): void{
    this.moovSideNavRef.close();
    this.refreshMoovs();
  }

  moovExtended(moovId: string): void{
    this.refreshMoovs();
  }

  activeMoovUpdated(): void{
    this.refreshMoovs ();
  }

  getIsMissingRelationship(): void{
    this.personalUserService.isMissingRelationship(this.counterpartId).subscribe(result => {
      if (result){
        // We are missing relationship - see if the user have requested to ignore this
        if (this.personalUserService.shouldSkipRelationshipQuestion(this.user!.id, this.counterpartId)){
          // the user have asked to ignore this for now
          result = false;
        }
      }
      this.isMissingRelationship = result;
    })
  }

  getAlertsForCounterpart(): void{
    this.personalUserService.getAlertsForCounterpart(this.counterpartId).subscribe(alerts => {
      if (alerts){
        // console.log(`in TMV getAlertsForCounterpart alerts = ${JSON.stringify(alerts)}`);
        this.userAlerts = alerts;
      }
    })
  }

  getMemberScore(): void {
    // if (this.isMemberInCareerProccess){
    //   this.scoreDetails = {    userId: this.counterpartId, score: this.teamMemberDetails?.currTotalEnergy * 10, trend: 0, isScoreDataExistsAndRelevant: true, isTrendDataExistsAndRelevant: false}
    //     return;
    //   }
      

    this.motivationsService.getScoreForUser(this.counterpartId).subscribe(scoreDetails => {
      this.scoreDetails = scoreDetails;
    })
  }

  relationshipFeedbackDone(): void{
        this.getIsMissingRelationship();
    }

  relationshipFeedbackPostponed(): void{
      this.isMissingRelationship = false;
      
      // save the user preference
      this.personalUserService.postponeRelationshipsQuestion(this.user!.id, this.counterpartId);
    }

  isUserMale(): boolean{
      return (this.user!.gender == Gender.MALE);
  }

  presentActiveMoovs(): void{
    this.activeMoovsViewMode = MoovsViewPresentationModeEnum.ACTIVE_MOOVS;
  }

  presentPastMoovs(): void{
    this.activeMoovsViewMode = MoovsViewPresentationModeEnum.PAST_MOOVS;
  }

  activeMoovExtended(activeMoovId: string) :void{
    this.getActiveAndPastMoovs();
  }

  closeView() : void{
    this.closeEvent.emit();
  }

  closeMakeMoovWizard(): void{
    this.refreshMoovs();
    this.moovWizardOpened = false;
  }

  forcePresentNotUpdatedData (): void{
    this.isForcePresentNotUpdatedData = true;
  }

  sendReminder() : void{
    this.sendReminderAnimation();
    this.personalUserService.sendDiscoveryReminder(this.counterpartId).subscribe(res => {

    });
  }

  async  sendReminderAnimation(){
    this.state = 'out';
    this.state = 'in';
    this.showSendReminderBtn = false;
    await this.utilsService.delay(1);  
    this.state = 'out'
    await this.utilsService.delay(0.5);  
    this.showSendReminderBtn = true;
  }
}

export enum MoovsViewPresentationModeEnum{
  NONE = 0,
  ACTIVE_MOOVS = 1,
  PAST_MOOVS = 2
}